import { useEffect, useState } from 'react';
import { fetchServiceCustomization } from 'api/calendarSetting';
import { EServiceType } from 'types/common';

export type IServiceData = {
    displayName: string;
    description: string;
    duration: number;
    color: string;
    serviceType: EServiceType;
    id: number;
};

export const useCalendarCustomize = (): [IServiceData[], boolean, () => void] => {
    const [loading, setLoading] = useState(false);
    const [serviceData, setServiceData] = useState<IServiceData[]>([]);

    const fetchData = async () => {
        try {
            setLoading(true);
            const result = await fetchServiceCustomization();
            if (!result.error) {
                const data: IServiceData[] = result?.data?.data || [];
                setServiceData(data);
            }
            setLoading(false);
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        fetchData();
    }, []);

    return [serviceData, loading, fetchData];
};
